export const validCharsRegex = /^[^<>]+$/;

export const validCharsRegexWithCharacterRange = (min: number, max: number) => {
    return new RegExp(`^[^<>]{${min},${max}}`);
};
